import UpdateProductViewCount from "core-web/libs/GrebbCommerceAPI/Products/UpdateProductViewCount";
import { getModel } from "core-web/state";
import DataLayer from "./DataLayer";

export default (data) => {
    const product = data?.data;

    if (!product) {
        return;
    }

    const application = getModel("application");
    const { basketId } = getModel("basket") || {};

    DataLayer.track({
        algoliaDisplayedObjectIDs: product.part_no,
        event: "product_view",
        ecommerce: {
            basket: { id: basketId },
            detail: {
                products: [DataLayer.getProduct(product)],
            },
        },
        currency: application.currency.code,
    });

    // Track product view in API
    if (data?.data?.id && data?.data?.category_id) {
        UpdateProductViewCount(data.data.id, data.data.category_id);
    }
};
